import React, {Component} from 'react';
import "./Element.css"

class Element extends Component {
  render() {
    return (
      <div className="element">
        <div className="element-number">
          {this.props.element.Z}
        </div>
        <div className="element-symbol">
          {this.props.element.Symbol}
        </div>
        <div className="element-name">
          {this.props.element.Element}
        </div>
        <div className="element-name">
          {this.props.element["Atomic weight"]}
        </div>
      </div>
    );
  }
}

export default Element;



// WEBPACK FOOTER //
// ./src/components/Element.js